<template>
    <div>
        <!-- <v-card class="mb-4 mt-0" elevation="0"> -->
            <!-- <v-card-text> -->
                <v-row>
                    <v-col class="py-2">
                        <datePickerForm
                            label="Fecha"
                            :valueInput="values.date"
                            :rule="rules.required"
                            @valueChange="(v) => {values.date = v; delete serverErrors['date']}"
                            :errorMessages="serverErrors['date']"
                        ></datePickerForm>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="py-2">
                        <autocompleteOneForm
                            label="Agente aduanal"
                            :loading="loadingCustomsAgents"
                            :valueInput="values.customs_agent_id"
                            :rule="rules.required"
                            :items="serverItems.customsAgents"
                            :errorMessages="serverErrors.customs_agent_id"
                            @valueChange="(v) => {values.customs_agent_id = v; delete serverErrors.customs_agent_id}"
                        ></autocompleteOneForm>
                    </v-col>
                </v-row>
               
                <v-row>
                    <v-col class="py-2">
                        <autocompleteOneForm
                            label="Forma de pago"
                            :loading="loadingMethods"
                            :valueInput="values.payment_method_id"
                            :rule="rules.required"
                            :items="serverItems.methods"
                            :errorMessages="serverErrors.payment_method_id"
                            @valueChange="(v) => {values.payment_method_id = v;paymentMethodChanged(v); delete serverErrors.payment_method_id}"
                        ></autocompleteOneForm>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col class="py-2">
                        <autocompleteOneForm
                            :disabled="(values.payment_method_id === 'notas-de-credito' || values.payment_method_id === 'descuento')"
                            label="Cuenta bancaria"
                            :loading="loadingBankAccounts"
                            :valueInput="values.bank_account_id"
                            :rule="rules.bank"
                            :items="serverItems.bankAccounts"
                            :errorMessages="serverErrors.bank_account_id"
                            @valueChange="(v) => {values.bank_account_id = v; selectCurrency(v); delete serverErrors.bank_account_id}"
                        ></autocompleteOneForm>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col class="py-2">
                       <textFieldForm 
                            @valueChange="(v) => {values.commentary = v; delete serverErrors.commentary}" 
                            :valueInput="values.commentary" 
                            :rule="[]" 
                            label="Comentarios"
                            :errorMessages="serverErrors.commentary"
                        ></textFieldForm>
                    </v-col>
                </v-row>

                 <v-row>
                    <v-col class="py-2">
                        <textFieldForm 
                            @valueChange="(v) => {values.exchange_rate = v; exchangeUpdate(); delete serverErrors.exchange_rate}" 
                            :valueInput="values.exchange_rate" 
                            :rule="rules.current_mxn_per_usd" 
                            label="Tipo de cambio"
                            :errorMessages="serverErrors.exchange_rate"
                            :prefix="values.exchange_rate === '' ? '' : '$'"
                        ></textFieldForm>
                    </v-col>
                </v-row>


                <v-row>
                    <v-col class="py-2">
                        <fileInputForm
                            
                            label="Adjunto"
                            :multiple="false"
                            :valueInput="values.vaucher_file"
                            :url="values.vaucher_path"
                            :rule="[]"
                            @valueChange="(v) => {values.vaucher_file = v; delete serverErrors.vaucher_file}"
                            :errorMessages="serverErrors.vaucher_file"
                            v-on:update:url="values.vaucher_path = $event"
                        ></fileInputForm>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col class="py-0">
                        <h4>Cuentas de gastos</h4>
                    </v-col>
                </v-row>
                <v-row align="center">
                    <v-col class="py-2">
                        <autocompleteOneForm
                            
                            label="Cuenta por pagar"
                            :loading="loadingPayableAccounts"
                            :valueInput="values.payable_account_id"
                            :rule="[]"
                            :items="serverItems.payableAccounts"
                            :errorMessages="cxpSelectorError"
                            @valueChange="(v) => {values.payable_account_id = v; cxpSelectorError = ''; delete serverErrors.payable_account_id}"
                        ></autocompleteOneForm>
                    </v-col>
                    <v-col cols="4" sm="3" class="pl-0" >
                        
                        <primary-button :props="addBtnData" class=""></primary-button>
                       
                    </v-col>
                </v-row>

                <v-row>
                    <v-col>
                        <table-items  :props="tableProps" @methodHandler="method_handler" :items="values.balanceables">
                            <template v-slot:item.folio="props">
                                <span class="body-2">{{props.item.folio}}</span>
                            </template>
                            <template v-slot:item.total_text="props">
                                <span class="body-2">{{ut.currencyFormat(props.item.total,props.item.currency)}}</span>
                            </template>
                            <template v-slot:item.amount="props">
                                <div class="table-item">
                                    <v-text-field  :rules="rules.amount"  prefix="$" :suffix="values.currency? values.currency : props.item.currency" v-model="props.item.amount[values.currency? values.currency : props.item.currency]" @keyup="() => {updateTableItem(props.item); clearError(props.item)}"></v-text-field>
                            
                                </div>
                            </template>
                            <template v-slot:item.balance_due="props">
                                <span class="body-2">{{ut.currencyFormat(props.item.balance_due[values.currency? values.currency : props.item.currency],props.item.currency)}}</span>
                            </template>
                        </table-items>
                       <v-input class="warning--text caption" :error-messages="serverErrors.balanceables" v-model="values.balanceables" :rules="rules.balanceables"></v-input>
                    </v-col>
                </v-row>
               
                
                
                
            <!-- </v-card-text> -->
        <!-- </v-card> -->

    </div>
</template>

<script>
import TableItems from "../../incomes/TableItems.vue";
import Utils from '../../../helpers/Utils';

/* eslint-disable */
export default {
    props: ['values', 'serverErrors', 'edit'],
    components: {
       'table-items': TableItems
    },
    data(){
        return {
            cxpSelectorError: "",
            ut: Utils,
            
            loadingMethods: false,
            loadingBankAccounts: false,
            loadingPayableAccounts: false,

            loadingCustomsAgents: false,
            actions: [
				{
					name: 'Borrar',
					icon: {
						color: 'warning',
						icon: 'mdi-delete-outline'
					},
					disabled: false,
					type: 'method',   //  method, external, redirect
					action: 'deleteTableItem'
				},
			],
			tableProps: {
				headers: [
                     {
						text: 'Folio',
						align: 'left',
						value: 'folio',
                        sortable: false,
						class: 'table-b-border black--text'
					},
					{
						text: 'Adeudo',
						align: 'left',
						value: 'total_text',
						sortable: false,
						class: 'table-b-border black--text'
					},
                    {
						text: 'Monto',
						align: 'left',
						value: 'amount',
						sortable: false,
						class: 'table-b-border black--text'
					},
                    {
						text: 'Saldo',
						align: 'left',
						value: 'balance_due',
						sortable: false,
						class: 'table-b-border black--text'
					},
                   
					{
						text: '',
						align: 'right',
						sortable: false,
						value: 'actions',
						width: '5%',
						class: 'table-b-border black--text'
					}
				],
				items: this.values.balanceables,
				search: '',
				loading: false,
                keyValue: 0,
			},
            addBtnData: {
                text: "Agregar",
                	
                click: this.addCXP,
                block:true,
                loading: false,
            },
            rules: {
				required: [
					v => !!v || 'El campo requerido'
				],
                balanceables: [
                    v => {
                        if(this.values.balanceables.length === 0)
                            return 'Al menos una cuenta por pagar';
                        return true;
                    }
                ],
				
               
                amount: [
                    v => {
                        if(v!= null && !v.toString().match("^[0-9]+(\.[0-9]{1,4})?$"))
                            return 'Solo números válidos';
                        if(v === null || v.toString().trim() === '')
                            return 'El campo es requerido'
                        return true;
                    }
                ],
                balanceables: [
                    v => {
                        if(v.length == 0)
                            return 'Al menos una cuenta por cobrar';
                        return true;
                    }
                ],
                
                bank: [(v) => !!(this.values.payment_method_id === 'notas-de-credito' || this.values.payment_method_id === 'descuento'? true:v) || "Banco es requerido"],
				current_mxn_per_usd: [
                    v => {
                        if(v!= null && !v.toString().match("^[0-9]+(\.[0-9]{1,4})?$"))
                            return 'Solo números válidos';
                        if(v === null || v.toString().trim() === '')
                            return 'El campo es requerido';
                        if(v === 0 || v === '0' || v<=0)
                            return 'El campo debe ser máyor a 1';
                        return true;
                    }
                ],
            },
            items:{
                
                currency: [
                    {text: "MXN", value: "MXN"},
                    {text: "USD", value: "USD"}
                ],
                credit_period:[
                    {text: "0 DÍAS", value: '0'},
                    {text: "7 DÍAS", value: 7},
                    {text: "15 DÍAS", value: 15},
                    {text: "30 DÍAS", value: 30},
                    {text: "60 DÍAS", value: 60},
                    {text: "90 días", value: 90}
                ],
                paymentsBackup: [],
            },
            serverItems: {
                suppliers: [],
                methods: [],
                bankAccounts: [],
                payableAccounts: [],

                //
                customsAgents: [],

                
            },

          
        }
    },
    computed: {
        
    },
    watch: { 
        'values.customs_agent_id': function(v) {
            // console.log(v);
            this.clear();
            this.getPayableAccounts(v);
        }
    },
    mounted(){
       
        this.getPaymentMethods();
        this.getBankAccounts();
        //console.log(this.values);
        this.getPayableAccounts(this.values.customs_agent_id);
        this.getExchange();

        //
        this.getCustomsAgents();
    },
    methods: {
        method_handler(object){
			this[object.methodName](object.parameters)
		},
        getCustomsAgents()
        {
            this.loadingCustomsAgents = true;
            this.$api.customAgent.getSelect(this.$store.state.business)
				.then((resp) =>{
					//console.log(resp, "desde form");
					this.serverItems.customsAgents = resp.data;
				})
				.catch((error) =>{
					console.log(error, "error");
				})
				.finally(() => {
                    this.loadingCustomsAgents = false;
				})
			;
        },
        clearError(item)
        {
            let index =  Utils.getIndexArrayObject(this.values.balanceables, 'id', item.id);
            console.log(index, item);
            delete this.serverErrors[`balanceables.${index}.id`];
        },
        getExchange()
        {
            if(this.edit)
                return;
            this.$api.utils.getExchange()
                .then((resp) => {
                    this.values.exchange_rate =  parseFloat(resp.data.usd_to_mxn).toFixed(2);
                })
                .catch((error) => {
                    console.log(error);
                    this.values.exchange_rate = '';
                })
            ;
        },
        paymentMethodChanged(value)
        {
            if(value === 'notas-de-credito' || value === 'descuento')
            {
                this.values.bank_account_id = '';
            }
        },
        deleteTableItem(properties)
        {
            //let pos = Utils.getIndexArrayObject(this.tableProps.items,'id',  properties.id);
            
            //this.tableProps.items.splice(pos, 1);
            let pos =  Utils.getIndexArrayObject(this.values.balanceables, 'id', properties.id);
            this.values.balanceables.splice(pos, 1);

            let ret = this.items.paymentsBackup.find((itm) => itm.value == properties.id);
            if(ret != undefined)
                this.serverItems.payableAccounts.push(ret);
            this.values.payable_account_id = '';
            
        },
        updateTableItem(item)
        {
            let mxn = item.total - item.amount.MXN;
            let usd = item.total - item.amount.USD;
            if(item.currency === "USD"){
                usd = (item.total - item.amount.USD).toFixed(4);
                mxn = (item.total - (item.amount.MXN / this.values.exchange_rate)).toFixed(4);
            }

            if(item.currency === "MXN"){
                usd = (item.total - (item.amount.USD * this.values.exchange_rate)).toFixed(4);
                mxn = (item.total - item.amount.MXN).toFixed(4);
            }

            if(mxn == 0){
                mxn = Math.abs(mxn)
            }

            if(usd == 0){
                console.log("gere");
                usd = Math.abs(usd)
            }
            const new_balance_due = {MXN: mxn, USD: usd};
          
            const ind = Utils.getIndexArrayObject(this.values.balanceables,'id', item.id);
            this.values.balanceables[ind].balance_due = new_balance_due;

            return new_balance_due;
        },
        addCXP()
        {
            if(this.values.payable_account_id === '' || this.values.payable_account_id == undefined)
                this.cxpSelectorError = "Campo requerido";
            
            let cxp = this.values.payable_account_id;
            if(cxp == null || cxp == '' || cxp == undefined)
                return;
            console.log(this.serverItems.payableAccounts, 'itemss');
            let found = this.serverItems.payableAccounts.filter((itm) => itm.value == cxp)[0];
            let item = {
                id: found.slug,
                folio: found.folio,
                amount: this.updateAmount((found.total - found.balance), found.currency, this.values.exchange_rate??1),
                balance_due: {MXN: 0.00, USD: 0.00},
                total: found.total - found.balance,
                currency: found.currency,
                current_mxn_per_usd: this.values.exchange_rate??1,
                actions : JSON.parse(JSON.stringify(this.actions)),
                parameters: { id: found.slug },
            };

            this.values.balanceables.push(item);
            const pos = Utils.getIndexArrayObject(this.serverItems.payableAccounts,'value', cxp);
            this.serverItems.payableAccounts.splice(pos, 1);
            this.values.payable_account_id = '';
            delete this.serverErrors.balanceables;
            
        },

        updateAmount(total, item_currency, current_mxn_per_usd){
            let mxn = total;
            let usd = total;
            if(item_currency === "USD"){
                usd = (total).toFixed(4);
                mxn = (total * current_mxn_per_usd).toFixed(4);
            }
            if(item_currency === "MXN"){
                usd = (total / current_mxn_per_usd).toFixed(4);
                mxn = (total).toFixed(4);
            }
            const amount = {MXN: mxn, USD: usd};
            return amount;
        },

        selectCurrency(value){
            this.values.currency = "MXN";
            const bank_account = this.serverItems.bankAccounts.find( x => x.value === value);
            if(bank_account){
                this.values.currency = bank_account.currency;
            }
            for (let i = 0; i < this.values.balanceables.length; i++) {
                const element = this.values.balanceables[i];
                this.updateTableItem(element);
            }
        },
        exchangeUpdate()
        {
            console.log('ok');
            for (let i = 0; i < this.values.balanceables.length; i++) {
                const element = this.values.balanceables[i];
                this.updateTableItem(element);
            }
        },

       
        getSupliers()
        {
            this.loadingSupplier = true;
            this.$api.supplier.getSelectSuppliers(this.$store.state.business)
				.then((resp) =>{
					//console.log(resp, "desde form");
					this.serverItems.suppliers = resp.data;
				})
				.catch((error) =>{
					console.log(error, "error");
				})
				.finally(() => {
                    this.loadingSupplier = false;
				})
			;
        },

        getPaymentMethods()
        {
            this.loadingMethods = true;
            this.$api.paymentMethod.getSelect()
                .then((resp) => {
                    this.serverItems.methods = resp.data;
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loadingMethods = false;
                })
            ;
        },

        getBankAccounts()
        {
            this.loadingBankAccounts = true;
            this.$api.bank.accountGetSelect(this.$store.state.business)
                .then((resp) => {
                    //console.log(resp.data)
                    resp.data.forEach(element => {
                        this.serverItems.bankAccounts.push({
                            text: element.text,
                            value: element.value,
                            currency: element.currency,
                        });
                    });
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loadingBankAccounts = false;
                })
            ;
        },
        
        getPayableAccounts(customAgent)
        {
            this.serverItems.payableAccounts = [];
            if(customAgent == '' || customAgent == null || customAgent == undefined)
                return null;
            this.loadingPayableAccounts = true;
            this.$api.agentPayableAccount.getPayableAccounts(this.$store.state.business, customAgent)
                .then((resp) => {
                    //console.log(resp.data);
                    resp.data.forEach(itm => {
                        this.serverItems.payableAccounts.push({
                            ...itm,
                            text: itm.folio,
                            value: itm.slug
                        });
                        this.items.paymentsBackup.push({
                            ...itm,
                            text: itm.folio,
                            value: itm.slug
                        });
                    });
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loadingPayableAccounts = false;
                })
            ;
        },
        clear()
        {
            this.tableProps.items = [];
            this.items.paymentsBackup = [];
            this.values.balanceables = [];
            this.serverItems.payableAccounts = [];
        }

    }
}
</script>

<style>

</style>